<template>
    <div class="organization-team">
        <div class="title">
            <h3>
                <em></em>
                <span>{{ t('organizationTeam.title') }}</span>
                <em></em>
            </h3>
        </div>
        <div class="members">
            <div v-for="member in organizationTeam" :key="member.id" class="member">
                <img :src="require('@/assets/organization_team/' + member.avatar)" alt="">
                <p>{{ t(member.name) }}</p>
            </div>
        </div>
    </div>
</template>

<script setup>
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const organizationTeam = [
    // {
    //     "id": "1",
    //     "avatar": t("organizationTeam.members.1.avatar"),
    //     "name": t("organizationTeam.members.1.name"),
    // },
    {
        "id": "2",
        "avatar": t("organizationTeam.members.2.avatar"),
        "name": t("organizationTeam.members.2.name"),
    },
    // {
    //     "id": "3",
    //     "avatar": t("organizationTeam.members.3.avatar"),
    //     "name": t("organizationTeam.members.3.name"),
    // },
    // {
    //     "id": "4",
    //     "avatar": t("organizationTeam.members.4.avatar"),
    //     "name": t("organizationTeam.members.4.name"),
    // }, 
    {
        "id": "5",
        "avatar": t("organizationTeam.members.5.avatar"),
        "name": t("organizationTeam.members.5.name"),
    },

    // {
    //     "id": "6",
    //     "avatar": t("organizationTeam.members.6.avatar"),
    //     "name": t("organizationTeam.members.6.name"),
    // }
    // {
    //     "id": "9",
    //     "avatar": 'Jianwei_Wang.png',
    //     "name": 'Jianwei Wang',
    // },
    // {
    //     "id": "7",
    //     "avatar": 'Daiyun_Han.png',
    //     "name": 'Daiyun Han',
    // },
    // {
    //     "id": "8",
    //     "avatar": "Shanqi_Han.png",
    //     "name": "Shanqi Han",
    // },
    {
        "id": "10",
        "avatar": "Kai_Wang.png",
        "name": "Kai Wang",
    }
]

</script>

<style scoped lang="scss">
.organization-team {
    padding: 40px 0;
    margin: 0 auto;
    background-color: #f3f3f3;

    .title {
        h3 {
            font-size: 30px;
            font-weight: bold;
            text-align: center;
            color: #303030;
            margin-bottom: 60px;

            span {
                margin: 0 40px;
            }

            em {
                display: inline-block;
                width: 54px;
                height: 14px;
                margin-bottom: 0;
                background: url('@/assets/tt.png');
                vertical-align: middle;
            }
        }
    }

    .members {
        display: flex;
        flex-direction: row;
        justify-content: space-evenly;
        gap: 10px;
        max-width: 1440px;
        margin: 0 auto;

        .member {
            display: flex;
            flex-direction: row;
            align-items: center;
            gap: 5px;

            img {
                width: 75px;
                height: 75px;
                border-radius: 50%;
            }

            p {
                font-size: 20px;
                font-weight: normal;
                color: #303030;
            }

        }

    }

    @media (max-width: 768px) {

        .title {
            em {
                width: 40px !important;
            }

            span {
                font-size: 22px;
                margin: 0 10px !important;
            }
        }

        .members {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            padding: 0 20px;

            .member {
                display: flex;
                flex-direction: row;
                align-items: center;
                width: 100%;
            }
        }

    }


}
</style>